import Reveal from '@/components/base/Reveal';

export default function Intro() {
  return (
    <section id="intro" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 md:grid-cols-2 md:items-center md:px-6">
        <Reveal>
          <div className="relative">
            <div className="overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=A%20single%20old%20brass%20pocket%20watch%20resting%20on%20a%20dusty%20wooden%20shelf%20inside%20a%20dim%20cozy%20general%20store%2C%20soft%20warm%20side%20lighting%2C%20gentle%20bokeh%20of%20paper%20lanterns%20behind%2C%20stylized%20painterly%20storybook%20illustration%2C%20warm%20amber%20and%20brown%20tones%2C%20nostalgic%20and%20tender%20mood%2C%20high%20detail&width=800&height=1000&seq=intro-shelf-item&orientation=portrait"
                alt="杂货铺旧物柜台上的一只旧怀表插画"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <span className="absolute -bottom-4 -right-3 flex h-20 w-20 items-center justify-center rounded-full bg-accent-500 text-background-50 shadow-md md:-right-5">
              <i className="ri-hand-heart-line text-3xl" />
            </span>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <span className="h-px w-8 bg-primary-500" />
              漫画简介
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black leading-snug md:text-4xl">
              一间没有标价的杂货铺，
              <br className="hidden md:block" />
              藏着人间的执念与温柔
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
              《洞洞杂货铺漫画》讲述的是深夜才会出现的奇妙店铺故事。它开在一条会移动的巷子里，柜台上的每件旧物都寄存着一位客人的心愿。主角小满机缘巧合成为这里的临时店员，在一次次「等价交换」中，目睹了重逢、遗憾、原谅与放下。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              作品以单元剧串起群像，再用一条贯穿始终的暗线收束全局，被读者称为「画面有温度、故事有余味」的治愈系代表作。无论是想快速了解故事梗概，还是细品分卷细节，这一页都能帮你捋清脉络。
            </p>

            <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {[
                { icon: 'ri-archive-2-line', title: '奇幻治愈', desc: '旧物寄情，温暖人心' },
                { icon: 'ri-film-line', title: '单元剧群像', desc: '一个客人一段故事' },
                { icon: 'ri-route-line', title: '主暗线并行', desc: '伏笔收束不落空' },
              ].map((item) => (
                <div key={item.title} className="rounded-lg border border-background-200/70 bg-background-100 p-4">
                  <i className={`${item.icon} text-xl text-accent-500`} />
                  <div className="mt-2 text-sm font-semibold text-foreground-950">{item.title}</div>
                  <div className="mt-1 text-xs text-foreground-600">{item.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}